interface ServiceBlockProps {
  step: string;
  title: string;
  text: string;
  className?: string;
}

const ServiceBlock = ({ ...props }: ServiceBlockProps) => {
  return (
    <div className={`w-full sm:w-6/12 lg:w-1/3 ${props.className}`}>
      <div className="flex h-full flex-col gap-7 p-16">
        <span className="text-ring text-lg sm:text-2xl lg:text-3xl">
          {props.step}
        </span>
        <span className="text-primary text-lg sm:text-2xl lg:text-3xl">
          {props.title}
        </span>
        <span className="text-ring">{props.text}</span>
      </div>
    </div>
  );
};

export default ServiceBlock;
